import basicRequest from "../../../core/redux/actions/request";

const PREFIX = "INVOICE_CLIENT_PURCHASE_ORDER_SHOW";
const getState = (state) => state.invoice.clientPurchaseOrderShow;

const {
    reset,

    getPattern,
    getEmptyRequestPattern,
    secondaryPostPattern,
    secondaryPutPattern,
    actionPutPattern,
    actionDeletePattern,
    actionPostPattern,
    secondaryReset: formReset,
    success,
    isSecondaryLoading,
    isLoaded,
    isLoading,
    getError,
    getData,
    getSecondaryData,
    getSecondarySuccess: getFormSuccess,
    getSecondaryError: getFormError,
    download: downloadFile,
} = basicRequest(PREFIX, getState);

export const load = (id) => getPattern("react/invoices/v1/" + id, {}, null);

export {
    reset,
    getData,
    isLoaded,
    isLoading,
    getError,
    getSecondaryData,
    getFormSuccess,
    isSecondaryLoading,
    formReset,
    getFormError,
    success,
};

export const accepted = (id) =>
    actionPutPattern(
        "react/invoices/v1/" + id + "/accepted",
        {},
        {
            message: "Updated",
            description: "The Invoice was accepted.",
        }
    );

export const revertAccepted = (id) =>
    actionPutPattern(
        "react/v1/purchaseOrder/revert-accepted/" + id + "/accepted",
        {},
        {
            message: "Updated",
            description: "The Invoice was reverted.",
        }
    );

export const removeJobFromInvoiceClient = (id, invoiceDetailId) =>
    actionDeletePattern(
        "react/invoices/v1/" + id + "/detail/" + invoiceDetailId,
        {},
        {
            message: "Removed",
            description: "The job was removed from the invoice",
        }
    );

export const createRectificationInvoiceClient = (id, invoiceDetailId, form) =>
    actionPostPattern("react/invoices/v1/" + id + "/rectification/" + invoiceDetailId, form, {
        message: "Updated",
        description: "Rectification created",
    });

export const includeRectificationInvoiceClient = (id, invoiceDetailId) =>
    actionPutPattern(
        "react/invoices/v1/" + id + "/rectification/" + invoiceDetailId,
        {},
        {
            message: "Updated",
            description: "Rectification included",
        }
    );

export const deleteRectificationInvoiceClient = (id, invoiceDetailId) =>
    actionDeletePattern(
        "react/invoices/v1/" + id + "/rectification/" + invoiceDetailId,
        {},
        {
            message: "Updated",
            description: "Rectification deleted",
        }
    );

export const download = (id) => downloadFile("react/invoices/v1/" + id + "/download.xlsx", "invoice");
